import api from '../api'

class GeneralService {
  //consults
	static getCoordsRestricted() {
		return api({
			url: 'coords-restricted'
		})
  }

  static getPriceDelivery() {
		return api({
			url: 'price-delivery-public'
		})
	}

}

export default GeneralService;
